export default "__VITE_ASSET__BGc63Q3s__"